import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import CommonSelect from "../../../../core/common/commonSelect";
import {
  allClass,
  names,
  status,
} from "../../../../core/common/selectoption/selectoption";
import TeacherModal from "../teacherModal";
import PredefinedDateRanges from "../../../../core/common/datePicker";
import Table from "../../../../core/common/dataTable/index";
import { TableData } from "../../../../core/data/interface";
import { RootState } from "../../../../core/data/redux/store";
// import { teacherLists } from "../../../../core/data/json/teacherlist";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import TooltipOption from "../../../../core/common/tooltipOption";
import { useSelector, useDispatch } from "react-redux";
import { deleteTeacherApi, fetchTeachersApi } from "../../../../core/data/services/teacherService";
import { fetchteachersSuccess } from "../../../../core/data/redux/teacherSlice";
import { Teacher } from "../../../../core/data/types/teacher";
import ErrorModal from "../../../../core/common/ErrorModal";
import SuccessModal from "../../../../core/common/successModal";

const TeacherList = () => {
  const routes = all_routes;
  // const data = teacherLists;
  const hasFetched = useRef(false);
  const dispatch = useDispatch();

  const [deleteTeacherId, setDeleteTeacherId] = useState<number | null>(null);

  // NEW: state for delete success/error modals
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    const fetchData = async () => {
      try {
        const fetchedTeachers = await fetchTeachersApi();
        console.log("Fetched teachers:", fetchedTeachers);
        dispatch(fetchteachersSuccess(fetchedTeachers));
      } catch (error: any) {
        console.error("Error fetching teacher:", error.message);
        // Optionally show error modal on initial fetch:
        // setErrorMessage("Failed to load teachers: " + (error.message || ""));
        // setShowError(true);
      }
    };
    fetchData();
  }, [dispatch]);

  // Fetch teacher list from Redux store
  const teacherList = useSelector((state: RootState) => state.teachers.teachers);

  // Handler to open delete modal and set teacher id
  const handleOpenDeleteModal = (id: number) => {
    setDeleteTeacherId(id);
    // The TeacherModal (confirmation) should open via data-bs attributes
  };

  // Handler to confirm delete
  const handleConfirmDelete = async () => {
    if (deleteTeacherId == null) return;
    try {
      await deleteTeacherApi(deleteTeacherId);
      // Refetch teachers after delete
      const updatedTeachers = await fetchTeachersApi();
      dispatch(fetchteachersSuccess(updatedTeachers));

      // Show success modal
      setSuccessMessage("Teacher deleted successfully.");
      setShowSuccess(true);
    } catch (error: any) {
      console.error("Error deleting Teacher:", error.message);
      const msg = error.message || "An error occurred while deleting.";
      setErrorMessage(msg);
      setShowError(true);
    } finally {
      setDeleteTeacherId(null);
    }
  };

  // Close handlers for modals
  const handleCloseErrorModal = () => {
    setShowError(false);
    setErrorMessage("");
  };
  const handleCloseSuccessModal = () => {
    setShowSuccess(false);
    setSuccessMessage("");
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string) => (
        <Link to={routes.teacherDetails} className="link-primary">
          {text}
        </Link>
      ),
      sorter: (a: TableData, b: TableData) => {
        // Assuming id is a number or string: adjust as needed
        const aStr = String(a.id), bStr = String(b.id);
        return aStr.localeCompare(bStr);
      },
    },
    {
      title: "Name",
      dataIndex: "firstName",
      render: (text: string, record: Teacher) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <ImageWithBasePath
              src={record.img}
              className="img-fluid rounded-circle"
              alt="img"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link to="#">{text}</Link>
            </p>
          </div>
        </div>
      ),
      sorter: (a: TableData, b: TableData) => {
        // Assuming firstName exists
        return String(a.firstName).localeCompare(String(b.firstName));
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a: TableData, b: TableData) =>
        String(a.email).localeCompare(String(b.email)),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a: TableData, b: TableData) =>
        String(a.phone).localeCompare(String(b.phone)),
    },
    {
      title: "Designation",
      dataIndex: "designation",
      sorter: (a: TableData, b: TableData) =>
        String(a.designation).localeCompare(String(b.designation)),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: Teacher) => (
        <div className="d-flex align-items-center">
          <div className="dropdown">
            <Link
              to="#"
              className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="ti ti-dots-vertical fs-14" />
            </Link>
            <ul className="dropdown-menu dropdown-menu-right p-3">
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to={routes.teacherDetails}
                >
                  <i className="ti ti-menu me-2" />
                  View Teacher
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to={routes.editTeacher.replace(":id", record.id?.toString())}
                  state={{ teacher: record }}
                >
                  <i className="ti ti-edit-circle me-2" />
                  Edit
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#login_detail"
                >
                  <i className="ti ti-lock me-2" />
                  Login Details
                </Link>
              </li>
              <li>
                <Link className="dropdown-item rounded-1" to="#">
                  <i className="ti ti-toggle-right me-2" />
                  Disable
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#delete-modal"
                  onClick={() => handleOpenDeleteModal(record.id)}
                >
                  <i className="ti ti-trash-x me-2" />
                  Delete
                </Link>
              </li>
            </ul>
          </div>
        </div>
      ),
    },
  ];

  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  // teacherList from Redux
  const tableData = teacherList;

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Teacher List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Peoples</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Teacher List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <Link
                  to={routes.addTeacher}
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Teacher
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Teachers List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Teachers List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width "
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 border-bottom pb-0">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Name</label>
                              <CommonSelect
                                className="select"
                                options={names}
                                defaultValue={names[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Class</label>
                              <CommonSelect
                                className="select"
                                options={allClass}
                                defaultValue={allClass[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={status}
                                defaultValue={status[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                  <Link
                    to="#"
                    className="active btn btn-icon btn-sm me-1 primary-hover"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={routes.teacherGrid}
                    className="btn btn-icon btn-sm bg-light primary-hover"
                  >
                    <i className="ti ti-grid-dots" />
                  </Link>
                </div>
                <div className="dropdown mb-3">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-sort-ascending-2 me-2" />
                    Sort by A-Z
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1 active">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Viewed
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Teacher List */}
              <Table dataSource={tableData} columns={columns} Selection={true} />
              {/* /Teacher List */}
            </div>
          </div>
          {/* /Teachers List */}
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Delete confirmation modal */}
      <TeacherModal onConfirmDelete={handleConfirmDelete} />

      {/* Error modal for delete or fetch errors */}
      <ErrorModal
        show={showError}
        message={errorMessage}
        onClose={handleCloseErrorModal}
      />

      {/* Success modal for delete success */}
      <SuccessModal
        show={showSuccess}
        message={successMessage}
        onClose={handleCloseSuccessModal}
      />
    </>
  );
};

export default TeacherList;
